import { render, staticRenderFns } from "./scrollBoard.vue?vue&type=template&id=852ff3cc&scoped=true"
import script from "./scrollBoard.vue?vue&type=script&lang=js"
export * from "./scrollBoard.vue?vue&type=script&lang=js"
import style0 from "./scrollBoard.vue?vue&type=style&index=0&id=852ff3cc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "852ff3cc",
  null
  
)

export default component.exports